module.exports = __webpack_public_path__ + "img/user-layer.58fff408.png";